import { getUser } from "../../Service/UserFactory";

export default function checkPermissionById(requiredPermissionId) {
  const user = getUser();
  const isUserAdmin = [1, 16].includes(user?.roles[0]?.id);
  const permissions = user?.roles[0]?.permissions;
  const userHasPermission = isUserAdmin || Boolean(permissions.find(p => parseInt(p.id) === requiredPermissionId));

  return userHasPermission
}